export type InvoiceStateColor = 'gray' | 'orange' | 'green' | 'red';

export enum InvoiceStateStatus {
  Processing = 'В обробці',
  Deleted = 'Видалено',
  NotFound = 'Номер не знайдено',
  InTransit = 'У дорозі',
  ArrivedAtBranch = 'Прибув у відділення',
  ArrivedAtStore = 'Прибув у пункт',
  ArrivedAtPostomat = 'Прибув у поштомат',
  Received = 'Отримано',
  ShipmentReceived = 'Відправлення отримано',
  AddressChanged = 'Змінено адресу',
  RecipientRefused = 'Відмова одержувача',
  StorageSuspended = 'Припинено зберігання',
  StorageWithFee = 'Платне зберігання',
  StorageFeeAccruing = 'Нараховується плата за зберігання',
  Waiting = 'Нова пошта очікує надходження від відправника',
  CustomsClearance = 'Митне оформлення',
  CargoNotFound = 'Вантаж не знайдено',
  ProhibitedContents = 'Заборонений вміст',
  DestroyedByAttack = 'Знищено внаслідок атаки',
}

export enum InformerPosition {
  Start = 'start',
  EndTop = 'end-top',
  EndBottom = 'end-bottom',
}

export interface InvoiceStateConfig {
  id: string;
  shortName: InvoiceStateStatus;
  color: InvoiceStateColor;
  progressPercent: number;
  informerPosition: InformerPosition;
  informerIcon?: string;
  showNote?: boolean;
}
// @TODO remove this mapper when possible. It leads to weird invoices sorting
export const states: { [key: string]: InvoiceStateConfig } = {
  1: {
    id: '1',
    shortName: InvoiceStateStatus.Processing,
    color: 'gray',
    progressPercent: 25,
    informerIcon: 'schedule',
    informerPosition: InformerPosition.Start,
  },
  2: {
    id: '6',
    shortName: InvoiceStateStatus.Deleted,
    color: 'red',
    progressPercent: 100,
    informerIcon: 'clear',
    informerPosition: InformerPosition.EndBottom,
  },
  3: {
    id: '6',
    shortName: InvoiceStateStatus.NotFound,
    color: 'red',
    progressPercent: 100,
    informerPosition: InformerPosition.EndBottom,
  },
  30: {
    id: '3',
    shortName: InvoiceStateStatus.CustomsClearance,
    progressPercent: 70,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  31: {
    id: '3',
    shortName: InvoiceStateStatus.CustomsClearance,
    progressPercent: 70,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  4: {
    id: '2',
    shortName: InvoiceStateStatus.InTransit,
    color: 'orange',
    progressPercent: 50,
    informerIcon: 'pin_drop',
    informerPosition: InformerPosition.Start,
  },
  41: {
    id: '2',
    shortName: InvoiceStateStatus.InTransit,
    color: 'orange',
    progressPercent: 50,
    informerPosition: InformerPosition.Start,
  },
  5: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    color: 'orange',
    progressPercent: 70,
    informerIcon: 'pin_drop',
    informerPosition: InformerPosition.Start,
  },
  6: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    color: 'orange',
    progressPercent: 70,
    informerIcon: 'pin_drop',
    informerPosition: InformerPosition.Start,
  },
  7: {
    id: '4',
    shortName: InvoiceStateStatus.ArrivedAtBranch,
    color: 'orange',
    progressPercent: 100,
    informerIcon: 'pin_drop',
    informerPosition: InformerPosition.EndTop,
  },
  8: {
    id: '4',
    shortName: InvoiceStateStatus.ArrivedAtBranch,
    color: 'orange',
    progressPercent: 100,
    informerIcon: 'pin_drop',
    informerPosition: InformerPosition.EndTop,
  },
  101: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    color: 'orange',
    progressPercent: 70,
    informerPosition: InformerPosition.Start,
  },
  9: {
    id: '5',
    shortName: InvoiceStateStatus.Received,
    color: 'green',
    progressPercent: 100,
    informerIcon: 'check',
    informerPosition: InformerPosition.EndBottom,
  },
  10: {
    id: '5',
    shortName: InvoiceStateStatus.Received,
    color: 'green',
    progressPercent: 100,
    informerIcon: 'check',
    informerPosition: InformerPosition.EndBottom,
  },
  11: {
    id: '5',
    shortName: InvoiceStateStatus.Received,
    color: 'green',
    progressPercent: 100,
    informerIcon: 'check',
    informerPosition: InformerPosition.EndBottom,
  },
  13: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    progressPercent: 70,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  16: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    progressPercent: 100,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  14: {
    id: '4',
    shortName: InvoiceStateStatus.Received,
    color: 'orange',
    progressPercent: 100,
    informerIcon: 'check',
    informerPosition: InformerPosition.EndTop,
  },
  99: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    progressPercent: 70,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  104: {
    id: '5',
    shortName: InvoiceStateStatus.AddressChanged,
    color: 'green',
    progressPercent: 100,
    informerIcon: 'restart_alt',
    informerPosition: InformerPosition.EndBottom,
  },
  106: {
    id: '5',
    shortName: InvoiceStateStatus.Received,
    color: 'green',
    progressPercent: 100,
    informerIcon: 'check',
    informerPosition: InformerPosition.EndBottom,
  },
  102: {
    id: '6',
    shortName: InvoiceStateStatus.RecipientRefused,
    color: 'red',
    progressPercent: 100,
    informerIcon: 'clear',
    informerPosition: InformerPosition.EndBottom,
  },
  103: {
    id: '6',
    shortName: InvoiceStateStatus.RecipientRefused,
    color: 'red',
    progressPercent: 100,
    informerIcon: 'clear',
    informerPosition: InformerPosition.EndBottom,
    showNote: true,
  },
  108: {
    id: '6',
    shortName: InvoiceStateStatus.RecipientRefused,
    color: 'red',
    progressPercent: 100,
    informerIcon: 'clear',
    informerPosition: InformerPosition.EndBottom,
  },
  105: {
    id: '6',
    shortName: InvoiceStateStatus.StorageSuspended,
    color: 'red',
    progressPercent: 100,
    informerPosition: InformerPosition.EndBottom,
  },
  107: {
    id: '4',
    shortName: InvoiceStateStatus.ArrivedAtBranch,
    color: 'orange',
    progressPercent: 100,
    informerIcon: 'check',
    informerPosition: InformerPosition.EndTop,
  },
  12: {
    id: '1',
    shortName: InvoiceStateStatus.Processing,
    color: 'gray',
    progressPercent: 25,
    informerIcon: 'schedule',
    informerPosition: InformerPosition.Start,
  },
  111: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    color: 'orange',
    progressPercent: 70,
    informerPosition: InformerPosition.Start,
  },
  112: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    color: 'orange',
    progressPercent: 70,
    informerPosition: InformerPosition.Start,
  },
  113: {
    id: '6',
    shortName: InvoiceStateStatus.StorageSuspended,
    progressPercent: 100,
    color: 'red',
    informerPosition: InformerPosition.EndBottom,
  },
  115: {
    id: '3',
    shortName: InvoiceStateStatus.CustomsClearance,
    progressPercent: 70,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  116: {
    id: '3',
    shortName: InvoiceStateStatus.CustomsClearance,
    progressPercent: 100,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  117: {
    id: '6',
    shortName: InvoiceStateStatus.CargoNotFound,
    progressPercent: 100,
    color: 'red',
    informerPosition: InformerPosition.EndBottom,
  },
  118: {
    id: '6',
    shortName: InvoiceStateStatus.ProhibitedContents,
    progressPercent: 100,
    color: 'red',
    informerPosition: InformerPosition.EndBottom,
  },
  119: {
    id: '3',
    shortName: InvoiceStateStatus.CustomsClearance,
    progressPercent: 70,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  120: {
    id: '3',
    shortName: InvoiceStateStatus.CustomsClearance,
    progressPercent: 100,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  121: {
    id: '3',
    shortName: InvoiceStateStatus.InTransit,
    progressPercent: 70,
    color: 'orange',
    informerPosition: InformerPosition.Start,
  },
  124: {
    id: '6',
    shortName: InvoiceStateStatus.DestroyedByAttack,
    progressPercent: 100,
    color: 'red',
    informerPosition: InformerPosition.EndBottom,
  },
  999: {
    id: '',
    shortName: InvoiceStateStatus.Processing,
    progressPercent: 100,
    color: 'gray',
    informerPosition: InformerPosition.Start,
  },
};
